export default "__VITE_ASSET__e757068e__"